export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

// These are react-video-player's default values.
const VIDEO_WIDTH = 640;
const VIDEO_HEIGHT = 360;

export async function getThumbnailFromDataURL(
  url: string,
  width?: number,
  height?: number
): Promise<string> {
  return new Promise((resolve) => {
    const video = document.createElement("video");
    video.width = width || VIDEO_WIDTH;
    video.height = height || VIDEO_HEIGHT;
    video.src = url;
    video.muted = true;
    video.playsInline = true;
    video.preload = "metadata";

    const canvas = document.createElement("canvas");
    canvas.width = VIDEO_WIDTH;
    canvas.height = VIDEO_HEIGHT;
    const context = canvas.getContext("2d");

    video.onloadeddata = () => {
      context?.drawImage(video, 0, 0, canvas.width, canvas.height);
      video.pause();
      resolve(canvas.toDataURL("image/jpeg"));
    };

    video.play(); // we have to play the video so that we can get the first frame
  });
}
